import authRequest from '../authRequest';
import PatientPresenter from '../../presenters/PatientPresenter';

export default async function fetchPatient(uuid) {
  const response = await authRequest(`/patients/${uuid}`, { method: 'GET' });
  if (response.status !== 200) throw new Error('Failed to fetch patient');
  return new PatientPresenter(response.data);
}
